import { Box, Typography } from "@mui/material";
import { Quiz } from "@mui/icons-material";
import { useFields } from "../../../../api/useFields";
import { formatDateCompact } from "../../../../utils/dateUtils";
import { findField } from "../../../../utils/findField";
import { getChipLabel } from "../../../../components/chips/CustomChip";
import { ColoredLabelChip } from "../../../../components/chips/ColoredLabelChip";
import { BaseTimelineItem } from "./BaseTimelineItem";
import type { LogbookCustomerSurveyItem } from "../../types";

type LogbookCustomerSurveyItemProps = {
	customerSurvey: LogbookCustomerSurveyItem;
	isSelected: boolean;
	onClick: () => void;
	linkUrl?: string;
};

const customerSurveyAccent = "#f9a825";

export const LogbookCustomerSurveyItemComponent = ({ customerSurvey, isSelected, onClick, linkUrl }: LogbookCustomerSurveyItemProps) => {
	const dateLabel = formatDateCompact(customerSurvey.date_created);
	const { formatedFields } = useFields("customer_surveys");
	const momentField = findField(formatedFields, "moment");
	const momentLabel = momentField ? getChipLabel(momentField, customerSurvey.moment) : "";
	const statusField = findField(formatedFields, "status");
	const statusColor = statusField?.settings?.display_options?.choices?.find((choice: any) => choice.value === customerSurvey.status);
	const chipColor = statusColor?.background ?? customerSurveyAccent;

	return (
		<BaseTimelineItem config={{
			accentColor: customerSurveyAccent,
			icon: <Quiz sx={{ fontSize: 14, color: customerSurveyAccent }} />,
			isSelected,
			linkUrl,
		}}>
			<Box onClick={onClick} sx={{ flex: 1, cursor: "pointer" }}>
				<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
					<Typography variant="body2" fontWeight={600} color={customerSurveyAccent}>
						Questionário de Satisfação{momentLabel ? ` ${momentLabel}` : ""}
					</Typography>
					{statusField && customerSurvey.status && (
						<Box sx={{ transform: "scale(0.8)", transformOrigin: "left center" }}>
							<ColoredLabelChip label={getChipLabel(statusField, customerSurvey.status) ?? ""} color={chipColor} />
						</Box>
					)}
				</Box>
				<Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block", fontSize: "0.65rem" }}>
					{dateLabel}
				</Typography>
			</Box>
		</BaseTimelineItem>
	);
};
